import * as angular from "angular";
import * as _ from "lodash";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {PackingStatusType} from "../types/packing-status.type";
import {ApiConfig} from "../../commons/models/api-config.model";
import {ActionReasonEnum} from "../../action-reasons/enums/action-reason.enum";
import {AgentType} from "../../agents/types/agent.type";
import {ServicesUpdateMetadataRequestModel} from "../models/services-update-metadata-request.model";
import {MissingItemModel} from "../models/missing-item.model";
import {OperationalContactModel} from "../../commons/angular/models/operational-contact.model";
import {
  ServicesMovePackagesPayloadModel,
  SplitServicesPayloadModel
} from "../models/services-move-packages-payload.model";
import {SuperSearchSortMethodType} from "../../search/types/super-search-sort-method.type";
import {
  ServicesBulkEditLocationRequestModel,
  ServicesBulkUpdateRequestModel,
  ServicesBulkUpdateTaskSpecRequestModel
} from "../models/services-bulk-request.model";

export class DeliveriesRequestsService {

  /* @ngInject */
  constructor(private $deliveries, private DeliveriesAPI, private apiConfig: ApiConfig, private $http: IHttpService,
              private $q: IQService, private splitService: SplitService, private Upload) {
  }

  // ******************************
  //        Public methods
  // ******************************

  getTotalsBySiteId(from, to, areaIds, siteId) {
    var api = this.DeliveriesAPI.actions.getTotals;
    return this.$$call(api, {from: from, to: to, areaIds: areaIds, siteId: siteId}, {}, {});
  }

  getTotalsOverviewBySiteId(from, to, siteId) {
    var url = this.apiConfig.baseUrl + `/services/totals/statuses?from=` + from + '&to=' + to + '&siteId=' + siteId;
    return this.$http.get(url)
      .then((response) => {
        return this.$q.when(response.data);
      })
  }

  updateCompletedService(serviceId: string, service: any) {
    var api = this.DeliveriesAPI.actions.updateCompletedService;
    return this.$$call(api, {}, service, {id: serviceId});
  }

  getTotals(from, to, serviceTypes?, branchIds?, depotIds?, accountIds?, agentAccountIds?,
            agentIds?, areaIds?, noArea?, noPickUpArea?, noDropOffArea?, beforeTimeWindow?,
            afterTimeWindow?, inRoute?, isPacked?, packingStatuses?: PackingStatusType[], labelNames?, tagNames?,
            vehicleTypeIds?, riskTypes?, programTypes?, taskApprovalStatuses?, dispatchQuoteTypes?, isMissingPackages?,
            packagesIds?, configuredFieldName?, configuredFieldValue?, agentBranchIds?, reasonType?: ActionReasonEnum[], agentTypes?: AgentType, teamIds?: string[]) {

    var api = this.DeliveriesAPI.actions.getTotals;
    return this.$$call(api, {
      from: from,
      to: to,
      serviceTypes: serviceTypes,
      branchIds: branchIds,
      agentBranchIds: agentBranchIds,
      depotIds: depotIds,
      accountIds: accountIds,
      agentAccountIds: agentAccountIds,
      agentIds: agentIds,
      teamIds: teamIds,
      areaIds: areaIds,
      noArea: noArea,
      noPickUpArea: noPickUpArea,
      noDropOffArea: noDropOffArea,
      beforeTimeWindow: beforeTimeWindow,
      afterTimeWindow: afterTimeWindow,
      taskApprovalStatuses: taskApprovalStatuses,
      inRoute: inRoute,
      isPacked: isPacked,
      packingStatus: packingStatuses,
      label: labelNames,
      tagNames: tagNames,
      vehicleTypeIds: vehicleTypeIds,
      riskTypes: riskTypes,
      programType: programTypes,
      dispatchQuoteType: dispatchQuoteTypes,
      missingPackageItems: isMissingPackages,
      packageTypes: packagesIds,
      configuredFieldId: configuredFieldName,
      configuredFieldValue: configuredFieldValue,
      reasonType: reasonType,
      agentTypes: agentTypes
    }, {}, {});
  }

  updateServiceBilling(serviceId, billing) {
    const api = this.DeliveriesAPI.actions.updateServiceBilling;
    return this.$$call(api, {}, billing, {serviceId: serviceId});
  }

  updateServiceProNumber(service) {
    const api = this.DeliveriesAPI.actions.updateServiceProNumber;
    return this.$$call(api, {}, service, {serviceId: service.id});
  }

  uploadDeliveriesExcel(file, accountId, resolveAddresses, customSchemaId?) {
    const siteId = this.splitService.getSiteId();
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/importers-orders/upload`,
      method: 'POST',
      params: {
        siteId: siteId,
        resolveAddresses: resolveAddresses,
        accountId: accountId,
        customSchemaId
      },
      data: {
        file: file
      }
    })
      .then((response) => {
        return this.$q.when(response.data);
      })
  }

  exportDeliveries(from, to, group, serviceTypes, branchIds, depotIds, accountIds, agentAccountIds,
                   agentIds, query, areaIds, noArea, noPickUpArea, noDropOffArea, beforeTimeWindow,
                   afterTimeWindow, inRoute, isPacked, packingStatuses, labelNames, tagNames, vehicleTypeIds, riskTypes, type, taskApprovalStatuses,
                   dispatchQuoteTypes, programTypes, isMissingPackages, packagesIds, configuredFieldName, configuredFieldValue, agentBranchIds, reasonType?: ActionReasonEnum[], agentType?: AgentType, payload?, teamIds?: string[]) {

    var api = this.DeliveriesAPI.actions.export;
    return this.$$call(api, {
      from: from,
      to: to,
      group: group,
      serviceTypes: serviceTypes,
      branchIds: branchIds,
      agentBranchIds: agentBranchIds,
      depotIds: depotIds,
      accountIds: accountIds,
      agentAccountIds: agentAccountIds,
      agentIds: agentIds,
      teamIds: teamIds,
      query: query,
      areaIds: areaIds,
      noArea: noArea,
      noPickUpArea: noPickUpArea,
      noDropOffArea: noDropOffArea,
      beforeTimeWindow: beforeTimeWindow,
      afterTimeWindow: afterTimeWindow,
      taskApprovalStatuses: taskApprovalStatuses,
      inRoute: inRoute,
      isPacked: isPacked,
      packingStatus: packingStatuses,
      labelNames: labelNames,
      tagNames: tagNames,
      vehicleTypeIds: vehicleTypeIds,
      riskTypes: riskTypes,
      type: type,
      zoneId: this.splitService.getTimeZone(),
      dispatchQuoteType: dispatchQuoteTypes,
      programType: programTypes,
      missingPackageItems: isMissingPackages,
      packageTypes: packagesIds,
      configuredFieldName: configuredFieldName,
      configuredFieldValue: configuredFieldValue,
      reasonType: reasonType,
      agentTypes: agentType
    }, payload, {});
  }

  getAnalysis(from, to, areaIds, considerAreas, considerTimeWindows, onlyInStore, maxDeliveries, onlyUnRouted, branchIds) {
    const api = this.DeliveriesAPI.actions.getAnalysis;
    let payload;

    if (!_.isArray(areaIds)) {
      areaIds = areaIds ? [areaIds] : [];
    }

    payload = considerAreas ?
      _.map(areaIds, (id) => {
        return {serviceAreaList: [id]}
      }) :
      [{serviceAreaList: areaIds}];

    return this.$$call(api,
      {
        from: from,
        to: to,
        maxPerRoute: maxDeliveries,
        considerTimeWindows: considerTimeWindows,
        onlyInStore: onlyInStore,
        onlyUnRouted: onlyUnRouted,
        branchIds: branchIds
      }, payload, {}
    );
  }

  mergeAnalysis(allSegments, mergeIds, maxDeliveries, branchId) {
    var api = this.DeliveriesAPI.actions.mergeAnalysis;
    return this.$$call(api, {maxPerRoute: maxDeliveries, mergeIds: mergeIds, branchId: branchId}, allSegments, {});
  }

  splitAnalysis(allSegments, splitIds, maxDeliveries, branchId) {
    var api = this.DeliveriesAPI.actions.splitAnalysis;
    return this.$$call(api, {maxPerRoute: maxDeliveries, splitIds: splitIds, branchId: branchId}, allSegments, {});
  }

  getAnalysisConfiguration(branchId?) {
    var api = this.DeliveriesAPI.actions.getAnalysisConfiguration;
    return this.$$call(api, {branchId: branchId}, {}, {});
  }

  setAnalysisConfiguration(payload, branchId) {
    var api = this.DeliveriesAPI.actions.setAnalysisConfiguration;
    return this.$$call(api, {branchId: branchId}, payload, {});
  }

  createRoutes(payload, autoAssign, considerTimeWindow, branchId) {
    var api = this.DeliveriesAPI.actions.createRoutes;
    return this.$$call(api, {
      branchId: branchId,
      considerTimeWindow: considerTimeWindow,
      autoAssign: autoAssign
    }, payload, {});
  }

  getGeneratingRoutes() {
    var api = this.DeliveriesAPI.actions.getGeneratingRoutes;
    return this.$$call(api, {}, {}, {});
  }

  cancelGeneratingRoutes() {
    var api = this.DeliveriesAPI.actions.cancelGeneratingRoutes;
    return this.$$call(api, {}, {}, {});
  }

  getGeneratingRouteById(id) {
    var api = this.DeliveriesAPI.actions.getGeneratingRouteById;
    return this.$$call(api, {}, {}, {id: id});
  }

  getAssignAgentData(deliveryIds?, type?, query?, group?, status?) {
    var api = this.DeliveriesAPI.actions.getAssignAgentData;
    return this.$$call(api, {ids: deliveryIds, type: type, query: query, group: group, status: status}, {}, {});
  }

  getAssignAgentDataByRoutes(routeIds?, type?, query?, group?, status?) {
    var api = this.DeliveriesAPI.actions.getAssignAgentData;
    return this.$$call(api, {routeIds: routeIds, type: type, query: query, group: group, status: status}, {}, {});
  }

  getAssignResourceAllocationData(deliveryIds, from, to, type, branchIds) {
    const api = this.DeliveriesAPI.actions.getAssignResourceAllocationData;
    const zoneId = this.splitService.getTimeZone();

    return this.$$call(api, {
      ids: deliveryIds,
      from: from,
      to: to,
      type: type,
      expand: false,
      branchIds: branchIds,
      zoneId: zoneId,
    }, {}, {});
  }

  addServicesToResource(deliveryIds, assignDeliveries, allocationInstanceId, resourceEventEntityId, supplyResourceSource, onlyOptimized, attachedVehicleToUpdate?: {
    type: string,
    id: string
  }, mainLogisticsVehicleToUpdate?: { type: string, id: string }) {
    const api = this.DeliveriesAPI.actions.addServicesToResource;

    return this.$$call(api,
      {ids: deliveryIds, assignDeliveries: assignDeliveries, onlyOptimized: onlyOptimized},
      {
        allocationInstanceId: allocationInstanceId,
        resourceEventEntityId: resourceEventEntityId,
        supplyResourceSource: supplyResourceSource,
        attachedLogisticsVehicleReferences: attachedVehicleToUpdate ? [attachedVehicleToUpdate] : undefined,
        mainLogisticsVehicleReference: mainLogisticsVehicleToUpdate
      },
      {}
    );
  }

  assignToAgent(deliveryIds, agentId, doForce?, doReset?, removeServiceFromRoute?) {
    var api = this.DeliveriesAPI.actions.assign;
    return this.$$call(api, {
      ids: deliveryIds,
      force: doForce,
      reset: doReset,
      removeServiceFromRoute: removeServiceFromRoute
    }, {}, {id: agentId});
  }

  reassignToAgent(deliveryIds, agentId, doForce, doReset, removeServiceFromRoute) {
    var api = this.DeliveriesAPI.actions.reassign;
    return this.$$call(api, {
      ids: deliveryIds,
      force: doForce,
      reset: doReset,
      removeServiceFromRoute: removeServiceFromRoute
    }, {}, {id: agentId});
  }

  autoAssignAgent(deliveryIds) {
    var api = this.DeliveriesAPI.actions.autoAssign;
    return this.$$call(api, {ids: deliveryIds}, {}, {});
  }

  reassignCanceledDropoff(deliveryIds) {
    var api = this.DeliveriesAPI.actions.reassignCanceledDropoff;
    return this.$$call(api, {ids: deliveryIds}, {}, {});
  }

  assignToRoute(deliveryIds, routeId, doForce) {
    var api = this.DeliveriesAPI.actions.assign;
    return this.$$call(api, {ids: deliveryIds, force: doForce}, {}, {id: routeId});
  }

  manualHandle(serviceIds, note) {
    const api = this.DeliveriesAPI.actions.manualHandle;
    return this.$$call(api, {}, {serviceIds: _.castArray(serviceIds), note: note}, {});
  }

  addNote(ids, note) {
    var api = this.DeliveriesAPI.actions.addNote;
    return this.$$call(api, {ids: ids}, note, {});
  }

  bulkSMS(ids, message, type) {
    var api = this.DeliveriesAPI.actions.bulkSMS;
    return this.$$call(api, {ids: ids, type: type}, message, {});
  }

  getBulkSMSTemplates() {
    var api = this.DeliveriesAPI.actions.bulkSMSTemplates;
    return this.$$call(api, {}, {}, {});
  }

  getRecurringServices(branchIds, accountIds) {
    var api = this.DeliveriesAPI.actions.getRecurringServices;
    return this.$$call(api, {branchIds: branchIds, accountIds: accountIds}, {}, {});
  }

  importRecurringServices(file, defaultAccountId) {
    const siteId = this.splitService.getSiteId();
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/importers-recurring-services/upload`,
      method: 'POST',
      params: {
        siteId: siteId,
        defaultAccountId: defaultAccountId,
        zoneId: this.splitService.getTimeZone()
      },
      data: {
        file: file
      }
    })
      .then((response) => {
        return this.$q.when(response.data);
      })
  }

  createRecurringService(recurringService) {
    var api = this.DeliveriesAPI.actions.createRecurringService;
    return this.$$call(api, {}, recurringService, {});
  }

  updateRecurringService(id, recurringService) {
    var api = this.DeliveriesAPI.actions.updateRecurringService;
    return this.$$call(api, {}, recurringService, {id: id});
  }

  deleteRecurringServices(ids) {
    var api = this.DeliveriesAPI.actions.deleteRecurringService;
    return this.$$call(api, {templateId: ids}, {}, {});
  }

  updateBulk(ids, payload, rePrice, sendSms?) {
    var api = this.DeliveriesAPI.actions.updateBulk;
    const body: ServicesBulkUpdateRequestModel = {filter: {ids: ids}, rePrice: rePrice, sendSms: sendSms, bulkServiceEdit: payload};
    return this.$$call(api, {}, body, {});
  }

  changeToBackInStore(backInStoreReason, serviceId) {
    var api = this.DeliveriesAPI.actions.backInStore;
    return this.$$call(api, {id: serviceId}, backInStoreReason, {});
  }

  getLogsTimeline(serviceId) {
    var api = this.DeliveriesAPI.actions.getLogsTimeline;
    return this.$$call(api, {}, {}, {id: serviceId});
  }

  cancelDelivery(ids, cancelReason) {
    var api = this.DeliveriesAPI.actions.cancel;
    return this.$$call(api, {ids: ids, removeServicesFromRoute: cancelReason.removeFromRoute}, cancelReason, {});
  }

  getGlobalSearch(query: string, orgId: string, siteId: string, branchIds: string[], cursor, limit: number, autoComplete: boolean = true,
                  sortMethod?: SuperSearchSortMethodType) {
    const api = this.DeliveriesAPI.actions.globalSearch;
    return this.$$call(api, {
      query: query,
      orgId: orgId,
      siteId: siteId,
      branchIds: branchIds,
      cursor: cursor,
      limit: limit,
      autoComplete: autoComplete,
      sortMethod: sortMethod
    }, {}, {});
  }

  getDeliveryBilling(serviceId: string) {
    const api = this.DeliveriesAPI.actions.getDeliveryBilling;
    return this.$$call(api, {}, {}, {serviceId: serviceId});
  }

  bulkUpdateLocation(payload, serviceIds, rePrice) {
    const api = this.DeliveriesAPI.actions.bulkUpdateLocation;
    const body: ServicesBulkUpdateTaskSpecRequestModel = {filter: {ids: serviceIds}, rePrice: rePrice, bulkServiceEditTasksSpec: payload};
    return this.$$call(api, {}, body, {});
  }

  bulkUpdateTaskSpec(payload) {
    const api = this.DeliveriesAPI.actions.bulkUpdateTaskSpec;
    const body: ServicesBulkEditLocationRequestModel = {filter: {ids: payload.serviceIds}, request: _.omit(payload, 'serviceIds')};
    return this.$$call(api, {}, body, {});
  }

  deleteNote(serviceId: string, noteId: string) {
    const api = this.DeliveriesAPI.actions.deleteNote;
    return this.$$call(api, {noteId: noteId}, {}, {serviceId: serviceId});
  }

  getExpenses(serviceId: string) {
    const api = this.DeliveriesAPI.actions.getExpenses;
    return this.$$call(api, {}, {}, {serviceId: serviceId});
  }

  getEditOrderOptions(serviceId: string) {
    const api = this.DeliveriesAPI.actions.getEditOrderOptions;
    return this.$$call(api, {}, {}, {serviceId: serviceId});
  }

  updateTaskLocation(serviceId: string, taskId: string, taskSpec: any, updateOrder?: boolean, sendSms?: boolean, rePrice?: boolean) {
    const api = this.DeliveriesAPI.actions.updateTaskLocation;
    return this.$$call(api, {
      updateOrder: updateOrder,
      sendSms: sendSms,
      rePrice: rePrice
    }, taskSpec, {serviceId: serviceId, taskId: taskId});
  }

  updateReferenceIds(serviceId: string, referenceIds: string[], updateOrder?: boolean) {
    const api = this.DeliveriesAPI.actions.updateReferenceIds;
    return this.$$call(api, {updateOrder: updateOrder}, referenceIds, {serviceId: serviceId});
  }

  unlinkRelatedTask(serviceId: string, taskId: string, relatedTaskId: string) {
    const api = this.DeliveriesAPI.actions.unlinkRelatedTask;
    return this.$$call(api, {taskId: taskId, relatedTaskId: relatedTaskId}, {}, {serviceId: serviceId});
  }

  updateServiceMetaData(serviceId: string, metaData: {key: string, value: string}[]) {
    const api = this.DeliveriesAPI.actions.updateServiceMetaData;
    return this.$$call(api, {}, metaData, {serviceId: serviceId});
  }

  updateServicesMetaData(payload: ServicesUpdateMetadataRequestModel) {
    const api = this.DeliveriesAPI.actions.updateServicesMetaData;
    return this.$$call(api, {}, payload, {});
  }

  updateMissingItem(serviceId: string, missingItems: MissingItemModel) {
    const api = this.DeliveriesAPI.actions.updateMissingItems;
    return this.$$call(api, {}, missingItems, {serviceId: serviceId});
  }

  updateOperationalContacts(serviceId: string, operationalContacts: OperationalContactModel[]) {
    const api = this.DeliveriesAPI.actions.updateOperationalContacts;
    return this.$$call(api, {}, operationalContacts, {serviceId: serviceId});
  }

  movePackages(serviceId: string, payload: SplitServicesPayloadModel) {
    const api = this.DeliveriesAPI.actions.movePackages;
    return this.$$call(api, {}, payload, {serviceId: serviceId});
  }


  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$deliveries().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .service('deliveriesRequestsService', DeliveriesRequestsService);
